import axios from 'axios';

export const getCredentials = async () => {
    const { data } = await axios.get('/api/credentials');
    return data;
};

export const saveCredentials = async (credentials) => {
    const { data } = await axios.post('/api/credentials', credentials);
    return data;
};

export const testCredentials = async (type) => {
    const { data } = await axios.post('/api/credentials/test', { type });
    return data;
};
